// extracted by mini-css-extract-plugin
export var grayCircle = "_di-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_di-1";
export var selectedCircle = "_di-2";
export var shippingOptionImage = "_di-3";
export var shippingOptionWidgetPreview = "_di-4";